export const THEME_CONFIG = {
    0: {
        color: '566076',
    },
    1: {
        color: '12B7F5',
    },
    2: {
        color: '0167ED',
    },
    3: {
        color: 'FF9232',
    },
    4: {
        color: 'EE685D',
    },
    5: {
        color: '34CC99',
    },
};


export const CUSTOMER_COLOR_VALUE = -1;
